export const searchStringToParams = (search) => {
    let result = {};
    if (search[0] === "?") {
        search = search.replace("?", "");
    }
    if (!search.length) {
        return result;
    }
    const segments = search.split("&");
    for (const segment of segments) {
        const [key, value] = segment.split("=");
        result = appendQueryParam(result, key, decodeURIComponent(value));
    }
    return result;
};
export const paramsToSearchString = (params) => {
    const urlParams = new URLSearchParams();
    for (const key in params) {
        const value = params[key];
        if (value === undefined) {
            continue;
        }
        if (Array.isArray(value)) {
            for (const arrayItemValue of value) {
                urlParams.append(key, arrayItemValue);
            }
        }
        else {
            urlParams.append(key, value);
        }
    }
    return "?" + urlParams.toString();
};
export const appendQueryParam = (params, key, value) => {
    const result = Object.assign({}, params);
    if (key in result) {
        if (!Array.isArray(result[key])) {
            // if we see a second identical query term, then this is an array of values,
            //  so transform the existing value to an array ...
            result[key] = [result[key]];
        }
        result[key] = [...result[key], value];
    }
    else {
        result[key] = value;
    }
    return result;
};
// note: if the param is not an array param then value is ignored
//  i.e. removeQueryParam({foo: "bar"}, "foo", "baz") will still remove foo
export const removeQueryParam = (params, key, value) => {
    if (!(key in params)) {
        return Object.assign({}, params);
    }
    if (Array.isArray(params[key])) {
        const nextArray = params[key].filter(item => item !== value);
        return Object.assign(Object.assign({}, params), { [key]: nextArray.length === 1
                ? nextArray[0] // demote the value from an array to a one-to-one value
                : nextArray });
    }
    return Object.assign(Object.assign({}, params), { 
        // we set this as undefined, rather than remove it, so that subsequent logic
        //  which may attempt to splice the old params with the new params knows that this
        //  key has been wiped.  Final logic will remove the param from the query string.
        [key]: undefined });
};
